module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_13.a6c24f05.png";